export default "__VITE_ASSET__ed9cf0a5__"